export * from './template-config.view';